import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as ExpandedIcon } from '@assets/icons/expanding-button.svg';

export const StyledContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  position: 'fixed',
  right: '0',
  zIndex: '$devTool',
});

export const StyledExpandButton = styled(ExpandedIcon, {
  cursor: 'pointer',
  height: '220px',
  marginRight: '$1',
  width: '20px',
});

export const StyledChildrenContainer = styled(Box, {
  background: '$teal800',
  border: '$borderWidths$1 solid $darkGray700',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.5s ease-in-out',
});
